import { render, staticRenderFns } from "./LicenceApplyDialog.vue?vue&type=template&id=12aedf9c&scoped=true"
import script from "./LicenceApplyDialog.vue?vue&type=script&lang=js"
export * from "./LicenceApplyDialog.vue?vue&type=script&lang=js"
import style0 from "./LicenceApplyDialog.vue?vue&type=style&index=0&id=12aedf9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aedf9c",
  null
  
)

export default component.exports